<ion-modal (willDismiss)="onWillDismiss($event)">
	<ng-template>
		<ion-header>
			<ion-toolbar class="ion-padding-horizontal">
				<ion-buttons slot="start">
					<button vQbutton="md" class="btn-red" (click)="close()">Cancel</button>
				</ion-buttons>
				<ion-title class="hidden text-center sm:flex">Credit Card Form</ion-title>
				<ion-buttons slot="end">
					<div id="focus-errors-payment">
						<button vQbutton="md" class="btn-gray" (click)="saveCard()" [disabled]="form.invalid">
							Save Card
						</button>
					</div>
				</ion-buttons>
			</ion-toolbar>
		</ion-header>
		<ion-content class="ion-padding">
			<form [formGroup]="form" (ngSubmit)="saveCard()" errorTailor>
				<!--License Scanner-->
				<div *ngIf="showScanner" accessControl feature="CREDIT_CARD_SCANNER">
					<div class="my-5">
						<button type="button" vQbutton="lg" class="btn-gray" (click)="initializeScanner()" expand="block">Scan Credit Card</button>
					</div>
					<div class="relative">
						<div class="absolute inset-0 flex items-center" aria-hidden="true">
							<div class="w-full border-t border-gray-300"></div>
						</div>
						<div class="relative flex justify-center">
							<span class="px-2 text-sm text-gray-500 bg-white">Or Enter Manually</span>
						</div>
					</div>
				</div>
				<!--Fields-->
				<ng-container>
					<div class="pl-3">
						<ion-item class="ion-no-padding" lines="none" [formGroup]="form">
							<!--Card Number-->
							<ion-grid>
								<ion-row>
									<ion-col size="12">
										<vquip-form-field>
											<label vqControl="label" position="floating" color="primary">Card
												Number</label>
											<input   vqControl formControlName="cardNumber" type="text">
										</vquip-form-field>
									</ion-col>
								</ion-row>
							</ion-grid>
						</ion-item>
						<!--Name on Card-->
						<ion-item class="ion-no-padding" lines="none" [formGroup]="form">
							<ion-grid>
								<ion-row>
									<ion-col size="12">
										<vquip-form-field>
											<label vqControl="label" position="floating" color="primary">Name on
												Card</label>
											<input   vqControl formControlName="nameOnCard" type="text">
										</vquip-form-field>
									</ion-col>
								</ion-row>
							</ion-grid>
						</ion-item>
						<ion-item class="ion-no-padding" lines="none">
							<ion-grid>
								<ion-row>
									<!--Expiration Month-->
									<ion-col size="6">
										<vquip-form-field>
											<label [formGroup]="form" vqControl="label" position="floating"
												   color="primary">
												Expiration Month
											</label>
											<ion-select controlCustomClass="my-custom-class other-custom-class"
														vqControl="select" formControlName="expirationMonth">
												<ion-select-option value="01">01</ion-select-option>
												<ion-select-option value="02">02</ion-select-option>
												<ion-select-option value="03">03</ion-select-option>
												<ion-select-option value="04">04</ion-select-option>
												<ion-select-option value="05">05</ion-select-option>
												<ion-select-option value="06">06</ion-select-option>
												<ion-select-option value="07">07</ion-select-option>
												<ion-select-option value="08">08</ion-select-option>
												<ion-select-option value="09">09</ion-select-option>
												<ion-select-option value="10">10</ion-select-option>
												<ion-select-option value="11">11</ion-select-option>
												<ion-select-option value="12">12</ion-select-option>
											</ion-select>
										</vquip-form-field>
									</ion-col>
									<!--Expiration Year-->
									<ion-col size="6">
										<vquip-form-field>
											<label [formGroup]="form" vqControl="label" position="floating"
												   color="primary">Expiration
												Year</label>
											<ion-select class="select-icon-inner"
														controlCustomClass="my-custom-class other-custom-class"
														vqControl="select" formControlName="expirationYear">
												<ion-select-option value="23">2023</ion-select-option>
												<ion-select-option value="24">2024</ion-select-option>
												<ion-select-option value="25">2025</ion-select-option>
												<ion-select-option value="26">2026</ion-select-option>
												<ion-select-option value="27">2027</ion-select-option>
												<ion-select-option value="28">2028</ion-select-option>
												<ion-select-option value="29">2029</ion-select-option>
												<ion-select-option value="30">2030</ion-select-option>
												<ion-select-option value="21">2031</ion-select-option>
												<ion-select-option value="32">2032</ion-select-option>
												<ion-select-option value="33">2033</ion-select-option>
												<ion-select-option value="34">2034</ion-select-option>
											</ion-select>
										</vquip-form-field>
									</ion-col>
								</ion-row>
							</ion-grid>
						</ion-item>
						<ion-item class="ion-no-padding" lines="none">
							<ion-grid>
								<ion-row>
									<!--CVV-->
									<ion-col size="4">
										<vquip-form-field>
											<label vqControl="label" position="floating" color="primary">CVV</label>
											<input   vqControl formControlName="cvv" type="string">
										</vquip-form-field>
									</ion-col>
								</ion-row>
							</ion-grid>
						</ion-item>
					</div>
				</ng-container>
			</form>
		</ion-content>
	</ng-template>
</ion-modal>
